module.exports = __webpack_public_path__ + "static/media/interactive-text.a391709e.svg";